import {request_async} from "@/utils/requestAsync";
import { API_URL_EXP_ADMIN} from "@/model/ConfigModel";

// 获取列表
export async function getList(params) {
  return request_async(API_URL_EXP_ADMIN + `admin/semester/list`, "get", params);
}
